export default import.meta.ROLLUP_FILE_URL_G_v03GxkBopPCA8ltyp9_w